/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Switch, Route } from "react-router-dom";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
// import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import Intro from "./modules/Intro/Intro";
import Privacy from "./modules/terms/Privacy";

export function Routes() {
    return (
        <Switch>

            {/* <Route path="/" component={Intro} /> */}
            <Route path="/intro" component={Intro} />
            <Route path="/privacy" component={Privacy} />
            {/*<Route path="/error" component={ErrorsPage}/>*/}
            <Layout>
                <BasePage />
            </Layout>
        </Switch>
    );
}
